
import {
  Mixins,
  Component,
  Watch,
} from 'vue-property-decorator';
import {
  Dialog,
  Button,
  Pagination,
} from 'element-ui';

import {
  tSearch,
} from '@/components/Search/index';
import {
  IBTNCONF,
} from '@/types/base.d';
import tableMixin from './tableMixin';
import addOrModify from './components/addOrModify.vue';
@Component({
  components: {
    Dialog,
    Button,
    Pagination,
    tSearch,
    addOrModify,
  },
})

export default class paperManage extends Mixins(tableMixin) {
  private isNeedAddOrModify = false;

  private actionBtns: Array < IBTNCONF > = [{
    title: '新增',
    name: '/paper/manage:add',
    icon: 'plus',
    callback: this.handleAddQuestion,
    log: {
      name: '题库 - 新增',
      component: '/paper/manage:add',
    },
  }];

  private echoData: any = {};

  /**
   * @author: LiuYongChun
   * @description: 试卷编辑
   * @param {*} id 试卷id
   * @return {*}
   */
  editItem(rowData: any) {
    this.showOrCloseAdd();
    this.echoData = rowData;
  }

  handleAddQuestion() {
    this.showOrCloseAdd();
    this.echoData = {};
  }

  showOrCloseAdd() {
    this.isNeedAddOrModify = !this.isNeedAddOrModify;
  }

  closeAddAndRefresh() {
    this.showOrCloseAdd();
    this.getData();
  }
}
